module.exports = __webpack_public_path__ + "media/country_flags/pt-3ca47aa2.png";